export const environment = {
    production: true,
    googleAnalyticsTrackingID: "G-RK07WLZZ4G",
    mailTokenId: "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJBZG1pbiIsInVzZXJEZXNjcmlwdGlvbiI6IkFkbWluIiwicm9sZXMiOltdLCJpc0VuYWJsZWQiOnRydWUsImV4cCI6MTczMDQ3MjEwNCwidXNlcklkIjoxLCJpYXQiOjE2OTg5MzYxMDR9.ARn3HPLY8JcO5bqbtgZosTx207F_xv6Wc9U1nEyeUbc",
    company: "anitia",
    contactTemplate: "anitiaContact",
    cookieBotDomainGroupId: "ec4b2667-0197-4ba1-8a8b-7fa368a193e7",
    companyEmail: "info@anitia.it"
}